import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import IconButton from 'LuxKit/Button/IconButton'
import config from 'constants/config'
import Group from 'components/utils/Group'
import initiateShareThis from 'components/Vendor/ShareThis/init'
import LineFacebookIcon from 'LuxKit/Icons/line/LineFacebookIcon'
import SolidTwitterIcon from 'LuxKit/Icons/solid/SolidTwitterIcon'
import LineWhatsappIcon from 'LuxKit/Icons/line/LineWhatsappIcon'
import LineLinkIcon from 'LuxKit/Icons/line/LineLinkIcon'
import { copyValueToClipboard } from 'lib/web/clipboardUtils'

interface Props {
  breadcrumb?: string
  competitionTitle?: string
}

export const NETWORKS = [
  {
    key: 'facebook',
    name: 'Facebook',
    icon: <LineFacebookIcon colour="normal-contrast" />,
  },
  {
    key: 'twitter',
    name: 'Twitter',
    icon: <SolidTwitterIcon colour="normal-contrast" />,
  },
  {
    key: 'whatsapp',
    name: 'WhatsApp',
    icon: <LineWhatsappIcon colour="normal-contrast" />,
  },
]

function ShareButtons({ competitionTitle, breadcrumb }: Props) {
  const intl = useIntl()

  useEffect(() => {
    initiateShareThis()
  }, [])

  const shareTitle = intl.formatMessage(
    {
      id: 'yj-4Ke05gy0yx4gow2CT',
      defaultMessage: 'I just received a prize from {competitionTitle}',
      description: 'Social share title after winning a competition prize',
    },
    { competitionTitle },
  )
  const shareMessage = intl.formatMessage(
    {
      id: 'qUOILTFPzA2JdrU_hpT9',
      defaultMessage: 'Join us on {competitionTitle} to win a trip!',
      description: 'Social share message inviting others to join a competition',
    },
    { competitionTitle },
  )

  const shareConfig = {
    url: `${config.SCHEME}://${config.CUSTOMER_PORTAL_HOST}/${breadcrumb}`,
    shareTitle,
    shareMessage,
  }

  return (
    <Group direction="horizontal" gap={8}>
      {NETWORKS.map((network) => (<IconButton
        key={network.key}
        kind="secondary"
        variant="dark"
        className="st-custom-button"
        data-network={network.key}
        data-url={shareConfig.url}
        data-title={shareConfig.shareTitle}
        data-description={shareConfig.shareMessage}
        shape="circle"
        size="large"

        children={network.icon}
      />
      ))}
      <IconButton
        key="carbon-copy"
        kind="secondary"
        variant="dark"
        className="st-custom-button"
        shape="circle"
        size="large"
        onClick={() => {
          copyValueToClipboard(shareConfig.url)
        }}
        children={<LineLinkIcon colour="normal-contrast" />}
      />
    </Group>
  )
}

export default ShareButtons
